var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.type === "appartment"
    ? _c("div", { staticClass: "c-listitem" }, [
        _c("div", { staticClass: "c-listitem-part" }, [
          _c("p", { staticClass: "c-listitem-text c-listitem-text--bold" }, [
            _vm._v(_vm._s(_vm.item.roomsNumber))
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "c-listitem-text c-listitem-text--grey" }, [
            _vm._v(_vm._s(_vm.item.roomText))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "c-listitem-part c-listitem-part--mid" }, [
          _vm.item.sizeFrom && _vm.item.sizeTo
            ? _c(
                "p",
                { staticClass: "c-listitem-text c-listitem-text--bold" },
                [
                  _vm._v(
                    _vm._s(_vm.item.sizeFrom) + " - " + _vm._s(_vm.item.sizeTo)
                  )
                ]
              )
            : _vm.item.sizeFrom || _vm.item.sizeTo
            ? _c(
                "p",
                { staticClass: "c-listitem-text c-listitem-text--bold" },
                [_vm._v(_vm._s(_vm.item.sizeFrom) + _vm._s(_vm.item.sizeTo))]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("p", { staticClass: "c-listitem-text c-listitem-text--grey" }, [
            _vm._v(_vm._s(_vm.item.sizeText))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "c-listitem-part c-listitem-part--last" }, [
          _c("p", { staticClass: "c-listitem-text c-listitem-text--grey" }, [
            _vm._v(_vm._s(_vm.item.totalAppartments))
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "c-listitem-text c-listitem-text--grey" }, [
            _vm._v(_vm._s(_vm.item.totalAppartmentsText))
          ])
        ])
      ])
    : _vm.type === "timeline"
    ? _c("div", { staticClass: "c-listitem" }, [
        _c("div", { staticClass: "c-listitem-part" }, [
          _c("p", { staticClass: "c-listitem-text c-listitem-text--grey" }, [
            _vm._v(_vm._s(_vm.item.label))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "c-listitem-part c-listitem-part--last" }, [
          _c(
            "p",
            {
              class: [
                "c-listitem-text",
                {
                  "c-listitem-text--bold": _vm.item.active,
                  "c-listitem-text--grey": !_vm.item.active
                }
              ]
            },
            [_vm._v(_vm._s(_vm.item.statusText))]
          )
        ])
      ])
    : _vm.type === "fullText"
    ? _c("div", { staticClass: "c-listitem" }, [
        _c("div", { staticClass: "c-listitem-part" }, [
          !_vm.item.url
            ? _c(
                "p",
                {
                  class: [
                    "c-listitem-text",
                    {
                      "c-listitem-text--bold": _vm.item.active,
                      "c-listitem-text--grey": !_vm.item.active
                    }
                  ]
                },
                [_vm._v(_vm._s(_vm.item.statusText))]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.item.url
            ? _c(
                "a",
                {
                  staticClass: "c-listitem-text",
                  attrs: { href: _vm.item.url }
                },
                [_vm._v("\n      " + _vm._s(_vm.item.statusText) + "\n    ")]
              )
            : _vm._e()
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }